import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { FiltroServicosModel } from "@/models/solicitacoes";

export interface IFiltroServicosStore extends VuexModule {
  filtroServicosModel: FiltroServicosModel | null;
}

const getDefaultState = () => {
  return {
    filtroServicosModel: null
  };
};

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "FiltroServicos",
})
class FiltroServicosStore extends VuexModule implements IFiltroServicosStore {
  filtroServicosModel: FiltroServicosModel | null = null;

  @Mutation
  RESET() {
    Object.assign(this, getDefaultState());
  }

  @Mutation
  SET_DADOS_BASICOS(payload: FiltroServicosModel) {
    this.filtroServicosModel = payload;
  }

  get filtroAtual() {
    return this.filtroServicosModel;
  }
}

export const filtroServicosStore = getModule(FiltroServicosStore);
